// extracted by mini-css-extract-plugin
export default {"authForm":"styles_authForm__kp-bK","title":"styles_title__3cjch","groups":"styles_groups__PSQbh","socials":"styles_socials__dojNa"};